import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { PaginatedResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

export type FetchAllFilesPayload = {
    fileName: string;
    workspaceId: number;
    pageIndex: number;
    pageSize: number;
    sortCriteria: "filename" | "fileSize" | "modifiedDate" | "workspaceId" | "groupId" | "size" | "ownerId";
    sortDirection: "asc" | "desc";
};
export async function fetchAllFiles(payload?: Partial<FetchAllFilesPayload>) {
    try {
        const endpoint = await RouteService.getStorageRoute();
        const response: AxiosResponse<PaginatedResponse<API.File>> = await HttpService.get(endpoint + "files/all", {
            params: {
                Filename: payload?.fileName,
                WorkspaceId: payload?.workspaceId,
                PageIndex: payload?.pageIndex,
                PageSize: payload?.pageSize,
                SortCriteria: payload?.sortCriteria,
                SortDirection: payload?.sortDirection,
            },
        });
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}
